import {
  aciAdd,
  aciAdult,
  aciAirConditioner,
  aciAllInclusive,
  aciArrowBack,
  aciArrowDown,
  aciArrowLeft,
  aciArrowRight,
  aciArrowUp,
  aciAtm,
  aciAward,
  aciBankCreditCard,
  aciBankCreditCardCash,
  aciBar,
  aciBeach,
  aciBeachPoolFacilities,
  aciBreakfast,
  aciBusinessCenter,
  aciCalendar,
  aciCard,
  aciCasino,
  aciCheckCircle,
  aciCheckIn,
  aciCheckSimple,
  aciChild,
  aciChildenClub,
  aciCinema,
  aciClock,
  aciClose,
  aciCloseCircle,
  aciCloseStrong,
  aciCoffe,
  aciConnectingRoom,
  aciCrib,
  aciCross,
  aciCrown,
  aciDateGo,
  aciDateReturn,
  aciDisney,
  aciDoubleArrowLeft,
  aciDoubleArrowRight,
  aciDown,
  aciFan,
  aciFilter,
  aciFirePlace,
  aciFlights,
  aciFreeBottledWater,
  aciFreeInternationalCalls,
  aciFreeToiletries,
  aciFrigobar,
  aciFullBoard,
  aciGameRoom,
  aciGift,
  aciGolf,
  aciGrade,
  aciGroceryShoppingService,
  aciGym,
  aciHairSalon,
  aciHotels,
  aciHousekeeping,
  aciInfo,
  aciInternetAdditionalCharges,
  aciKitchenFacilities,
  aciLaundry,
  aciLen,
  aciLibrary,
  aciLogin,
  aciMagic,
  aciMagicBand,
  aciMealplan,
  aciMeetingRoom,
  aciMegaphone,
  aciMenuItems,
  aciMicrowave,
  aciMoneyCircle,
  aciMorning,
  aciMultilingualStaff,
  aciNeighborhood,
  aciNewspaper,
  aciNight,
  aciNightclub,
  aciNoElevators,
  aciNoiseFreeRoom,
  aciNoiseFreeRoomsNotGuarantee,
  aciNoPetsAllowed,
  aciPackages,
  aciParking,
  aciPayAtDestination,
  aciPets,
  aciPicnicArea,
  aciPointer,
  aciPool,
  aciPoolBar,
  aciPoolChildren,
  aciPrivateBathroom,
  aciPrivateBeach,
  aciRestaurant,
  aciRoomService,
  aciSafeBox,
  aciSearch,
  aciSeparatBedrooms,
  aciSeparateLivingRoom,
  aciServices,
  aciShareBathroom,
  aciShoppingOnSite,
  aciSkiPassesAvailable,
  aciSleep,
  aciSmokeFree,
  aciSmokingAreas,
  aciSofaBed,
  aciSorting,
  aciSpa,
  aciStar,
  aciSteamRoom,
  aciSub,
  aciSuitcase,
  aciSun,
  aciTennis,
  aciTicket,
  aciTip,
  aciTransfer,
  aciTrash,
  aciTv,
  aciTvAccesories,
  aciUp,
  aciUpgradeDisney,
  aciUpgradeSports,
  aciVan,
  aciViewGarden,
  aciWaterPark,
  aciWeddingServices,
  aciWifi,
  aciExchange,
  aciWallet,
  aciBankFinancing,
  aciExclamationCircle,
} from '@am/common-svg-icons';

// Custom icons hotels
import {
  aciDiscountRate,
  aciHotelRecommend,
  aciInternet,
  aciSeparateBredroom,
  aciSoundprofedRooms,
} from './hotels';

import * as commonSvgIcons from '@am/common-svg-icons';

export const hotelsIcons = [
  ...Object.values(commonSvgIcons),
  aciDiscountRate,
  aciHotelRecommend,
  aciInternet,
  aciSeparateBredroom,
  aciSoundprofedRooms,
  aciAdd,
  aciAdult,
  aciAirConditioner,
  aciAllInclusive,
  aciArrowBack,
  aciArrowDown,
  aciArrowLeft,
  aciArrowRight,
  aciArrowUp,
  aciAtm,
  aciAward,
  aciBankCreditCard,
  aciBankCreditCardCash,
  aciBar,
  aciBeach,
  aciBeachPoolFacilities,
  aciBreakfast,
  aciBusinessCenter,
  aciCalendar,
  aciCard,
  aciCasino,
  aciCheckCircle,
  aciCheckIn,
  aciCheckSimple,
  aciChild,
  aciChildenClub,
  aciCinema,
  aciClock,
  aciClose,
  aciCloseCircle,
  aciCloseStrong,
  aciCoffe,
  aciConnectingRoom,
  aciCrib,
  aciCross,
  aciCrown,
  aciDateGo,
  aciDateReturn,
  aciDisney,
  aciDoubleArrowLeft,
  aciDoubleArrowRight,
  aciDown,
  aciExchange,
  aciExclamationCircle,
  aciFan,
  aciFilter,
  aciFirePlace,
  aciFlights,
  aciFreeBottledWater,
  aciFreeInternationalCalls,
  aciFreeToiletries,
  aciFrigobar,
  aciFullBoard,
  aciGameRoom,
  aciGift,
  aciGolf,
  aciBankFinancing,
  aciGrade,
  aciGroceryShoppingService,
  aciGym,
  aciHairSalon,
  aciHotels,
  aciHousekeeping,
  aciInfo,
  aciInternetAdditionalCharges,
  aciKitchenFacilities,
  aciLaundry,
  aciLen,
  aciLibrary,
  aciLogin,
  aciMagic,
  aciMagicBand,
  aciMealplan,
  aciMeetingRoom,
  aciMegaphone,
  aciMenuItems,
  aciMicrowave,
  aciMoneyCircle,
  aciMorning,
  aciMultilingualStaff,
  aciNeighborhood,
  aciNewspaper,
  aciNight,
  aciNightclub,
  aciNoElevators,
  aciNoiseFreeRoom,
  aciNoiseFreeRoomsNotGuarantee,
  aciNoPetsAllowed,
  aciPackages,
  aciParking,
  aciPayAtDestination,
  aciPets,
  aciPicnicArea,
  aciPointer,
  aciPool,
  aciPoolBar,
  aciPoolChildren,
  aciPrivateBathroom,
  aciPrivateBeach,
  aciRestaurant,
  aciRoomService,
  aciSafeBox,
  aciSearch,
  aciSeparatBedrooms,
  aciSeparateLivingRoom,
  aciServices,
  aciShareBathroom,
  aciShoppingOnSite,
  aciSkiPassesAvailable,
  aciSleep,
  aciSmokeFree,
  aciSmokingAreas,
  aciSofaBed,
  aciSorting,
  aciSpa,
  aciStar,
  aciSteamRoom,
  aciSub,
  aciSuitcase,
  aciSun,
  aciTennis,
  aciTicket,
  aciTip,
  aciTransfer,
  aciTrash,
  aciTv,
  aciTvAccesories,
  aciUp,
  aciUpgradeDisney,
  aciUpgradeSports,
  aciVan,
  aciViewGarden,
  aciWallet,
  aciWaterPark,
  aciWeddingServices,
  aciWifi,
];
